import * as React from 'react';

class HouseSvg extends React.Component<Svg.IProps, Svg.IState> {
  static defaultProps: Svg.IProps = { className: '' };

  render() {
    const { className, ...rest } = this.props;

    return (
      <svg
        viewBox="0 0 32 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`svg-icon house-svg ${className || 'm-3'}`}
        {...rest}
      >
        <path
          d="M30.9001 12.56L25.07 0.560002C24.9876 0.391699 24.8595 0.249958 24.7004 0.150944C24.5412 0.0519294 24.3575 -0.000373071 24.17 2.00323e-06H7.83005C7.64263 -0.000373071 7.45888 0.0519294 7.29975 0.150944C7.14062 0.249958 7.01252 0.391699 6.93005 0.560002L1.10005 12.56C1.02527 12.7126 0.990625 12.8818 0.999373 13.0515C1.00812 13.2212 1.05998 13.3859 1.15005 13.53C1.24012 13.6741 1.36543 13.7929 1.51416 13.8751C1.66288 13.9574 1.83011 14.0003 2.00005 14H6.00005V22C6.00005 22.2652 6.10541 22.5196 6.29294 22.7071C6.48048 22.8946 6.73483 23 7.00005 23H25C25.2653 23 25.5196 22.8946 25.7072 22.7071C25.8947 22.5196 26 22.2652 26 22V14H30C30.17 14.0003 30.3372 13.9574 30.4859 13.8751C30.6347 13.7929 30.76 13.6741 30.8501 13.53C30.9401 13.3859 30.992 13.2212 31.0007 13.0515C31.0095 12.8818 30.9748 12.7126 30.9001 12.56ZM24 21H8.00005V14H24V21ZM3.60005 12L8.46005 2H23.5401L28.4001 12H3.60005Z"
          fill="#EA1C0A"
        />
      </svg>
    );
  }
}

export default HouseSvg;
